import React from 'react';
import ColumnaBotoneraItem from '../ColumnaBotoneraItem.js';
import FilaTorneoParticipanteEditable from './FilaTorneoParticipanteEditable.js';
import IconoMovimiento from '../../UI/IconoMovimiento.js';
import IconoTitulo from '../../UI/IconoTitulo.js';
import { IconoOrganizador } from '../../UI/IconoOrganizador.js';
import { NombreEquipoTorneo } from '../../funciones/FuncionesEquipo.js';
import styles from '../CuadroListaEditable.module.css';
import styleCols from './TablaTorneoParticipantes.module.css';

const TablaTorneoParticipantes = (props) => {
  const lista = props.lista || []; // Asegurar que lista es al menos un array vacío
  const idElegido = props.idElegido;
  const onEditarItem = props.onEditarItem;
  const onEliminarItem = props.onEliminarItem;
  const onGuardarNuevo = props.onGuardarNuevo;
  const torneo = props.contexto?.torneo;
  const equiposDisponibles = props.contexto?.equiposDisponibles || [];
  const cantidadParticipantes = torneo?.cantidadParticipantes || 0;

  const esIdElegido = (idItem) => {
    return Number(idElegido) === Number(idItem);
  };

  // Calcular cuántas filas editables mostrar
  const cantidadCargados = lista.length;
  const filasEditablesNecesarias =
    cantidadParticipantes > cantidadCargados ? cantidadParticipantes - cantidadCargados : 0;

  const dePais = torneo && torneo.pais && torneo.pais.id;

  // En modo consulta (sin filas editables o sin permiso para editar), ocultar columnas título y movimiento
  const modoConsulta = filasEditablesNecesarias === 0 || !onGuardarNuevo;

  // Si no hay participantes cargados ni filas editables, no mostrar nada
  if (cantidadCargados === 0 && filasEditablesNecesarias === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <tr className={`${styles.titulos}`} key="0">
        <td className={`${styleCols.posicion}`} title="Posición Final">
          Pos
        </td>
        <td className={`${styleCols.equipo}`}>Equipo</td>
        <td className={`${styleCols.partidos}`} title="Partidos Jugados">
          PJ
        </td>
        {!dePais && (
          <td className={`${styleCols.organizador}`} title="Organizador">
            Org
          </td>
        )}
        {!modoConsulta && <td className={`${styleCols.titulo}`}>Título</td>}
        {!modoConsulta && <td className={`${styleCols.movimiento}`}>Mov</td>}
        <td className={`${styleCols.observaciones}`}>Observaciones</td>
        <td className={`${styles.editar}`}></td>
      </tr>
      {lista.map((item, index) => (
        <tr className={`${styles.valores} ${esIdElegido(item.id) && styles.elegido}`} key={index}>
          <td className={`${styleCols.posicion}`}>{item.posicionFinal || ''}</td>
          <td className={`${styleCols.equipo}`}>
            {NombreEquipoTorneo(item.equipo || item, torneo)}
            {item && <IconoOrganizador objeto={item} />}
            {item && <IconoTitulo objeto={item} />}
            {item && <IconoMovimiento objeto={item} />}
          </td>
          <td className={`${styleCols.partidos}`}>{item.partidosJugados || ''}</td>
          {!dePais && <td className={`${styleCols.organizador}`}>{item.organizador ? '✓' : ''}</td>}
          {!modoConsulta && <td className={`${styleCols.titulo}`}>{item.tituloObtenido || ''}</td>}
          {!modoConsulta && (
            <td className={`${styleCols.movimiento}`}>{item.movimientoDivisional || ''}</td>
          )}
          <td className={`${styleCols.observaciones}`}>{item.observaciones || ''}</td>
          <ColumnaBotoneraItem
            idItem={item.id}
            onEditarItem={onEditarItem}
            onEliminarItem={onEliminarItem}
          />
        </tr>
      ))}
      {onGuardarNuevo &&
        filasEditablesNecesarias > 0 &&
        Array.from({ length: filasEditablesNecesarias }).map((_, index) => (
          <FilaTorneoParticipanteEditable
            key={`editable-${index}`}
            item={null}
            torneo={torneo}
            equiposDisponibles={equiposDisponibles}
            onGuardar={onGuardarNuevo}
            onCancelar={null}
          />
        ))}
    </React.Fragment>
  );
};

export default TablaTorneoParticipantes;
